import clsx from 'clsx';
import './Button.css';

export const Button = ({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className,
  children,
  icon,
  ...props
}) => (
  <button
    className={clsx(
      'btn',
      `btn--${variant}`,
      `btn--${size}`,
      { 'btn--full': fullWidth },
      className,
    )}
    {...props}
  >
    {icon ? <span className="btn__icon">{icon}</span> : null}
    {children}
  </button>
);
